export default __webpack_public_path__ + "static/media/ic-closed-conversations.2f84ebda.svg";